module.exports = __webpack_public_path__ + "img/BannerMobile.88b31d3e.svg";